module.exports = __webpack_public_path__ + "static/media/windshield.6dff3620.svg";